import {
  adsExtensionDoubleListStyle,
  entitySelectorStyle,
  paginationStyle,
  statusStyle,
  searchboxStyle,
  tableStyle,
  glyphIconStyle,
  campaignMultiSelectorWithoutDropdownStyle,
  convertToLocalStyle,
  commonDoubleListBoxStyle,
  getColumnSolidBorderStyle,
  truncatedStyle,
} from '@bingads-webui-campaign-react/common-styles';

export const getCalloutExtensionStyles = (_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '@global': {
    '.bingads-campaign-react-sub-page-menu': {
      '& .compared-date-range-picker': {
        display: 'none',
      },
    },

    '.popover-content': {
      paddingTop: '20px',
      paddingLeft: '24px',
      paddingBottom: '20px',
      paddingRight: '24px',
    },

    '.extension-editor__container': {
      '& .alert-image': {
        marginTop: 0,
      },

      '& .has-error': {
        '& label': {
          color: palette.black,
        },

        '& ul': {
          listStyleType: 'none',
          paddingLeft: 0,
        },

        '& ul.error': {
          color: '#A80000',
        },
      },
    },
  },

  CalloutExtension: {
    '& #create-adextension-button': {
      marginTop: '13px',
    },

    '& .callout-extension-grid-container': {
      '& .grid-parent-container .adextensions-grid': {
        paddingLeft: '0px',

        '& .delivery-info': {
          '& .status-icon': {
            marginRight: 5,
            position: 'static',
          },
          '& .status-warning': {
            color: '#D83B01',
          },
          '& .iconba-Warning': {
            color: '#D83B01',
          },
          '& .status-error': {
            color: '#A80000',
          },
          '& .iconba-ErrorBadge': {
            color: '#A80000',
          },
        },

        '& .trigger-popup': {
          width: 'fit-content',
          cursor: 'pointer',
          display: 'inline',
          borderBottom: '1px dashed #0078D4',
        },

        '& .sticky-header thead tr:first-child': {
          display: 'none',
        },

        ...getColumnSolidBorderStyle(1, 2),
      },
    },
    ...convertToLocalStyle(glyphIconStyle({ palette })),
    ...truncatedStyle,
  },
  CalloutExtensionScopeContainer: {
    paddingLeft: '32px',


    '& .bulkedit.association-editor': {
      marginLeft: '0px',
      paddingLeft: '0px',
      width: '1500px',

      '& .doubleListBox  ': {
        '& .form-group': {
          margin: '0px',
        },

        '& .row': {
          marginLeft: '0px',
          marginRight: '0px',
        },

        '& .layout-columns-container': {
          '& .layout-columns-element:nth-child(2)': {
            width: '450px',
          },
          '& .layout-columns-element:nth-child(3)': {
            width: '450px',
          },
        },

        '& .dlb-filter-alignPlaceholder': {
          paddingLeft: '0px',
        },

        '& .searchbox-input': {
          width: '450px',
        },
      },

      '& .errors-container': {
        '& .status_error:before': {
          fontFamily: iconFontFamily,
          content: '"\\E946"',
          color: palette.redDark,
          marginRight: '4px',
          verticalAlign: 'middle',
        },
        '& .status_success:before': {
          fontFamily: iconFontFamily,
          content: '"\\E930"',
          color: palette.green,
          marginRight: '4px',
          verticalAlign: 'middle',
        },
        '& .error-grid-container': {
          paddingTop: '10px',
        },
      },
    },

    '& .bulkedit > .panel': {
      '& .panel-heading': {
        paddingLeft: '0px',
      },
      '& .panel-body': {
        paddingLeft: '0px',
      },
    },

    '& .form-group.save-bar': {
      paddingLeft: '0px',
    },
    ...commonDoubleListBoxStyle({ palette, iconFontFamily }),
    ...adsExtensionDoubleListStyle({ palette, iconFontFamily }),
    ...entitySelectorStyle({ palette, iconFontFamily }),
    ...searchboxStyle({ palette, iconFontFamily }),
    ...paginationStyle({ palette, iconFontFamily }),
    ...statusStyle({ palette, iconFontFamily }),
    ...tableStyle({ palette, iconFontFamily }),
    ...campaignMultiSelectorWithoutDropdownStyle({ palette, iconFontFamily }),
  },
});
